const map = {
	"./BAAC.png": 2909,
	"./BAY.png": 9268,
	"./BBL.png": 5084,
	"./CIMB.png": 8523,
	"./GHB.png": 4181,
	"./GSB.png": 988,
	"./HSBC.png": 2796,
	"./IBANK.png": 5163,
	"./ICBC.png": 1335,
	"./KBANK.png": 8641,
	"./KKP.png": 4314,
	"./KTB.png": 6237,
	"./LHB.png": 4750,
	"./PromptPay.png": 5148,
	"./SCB.png": 9256,
	"./TCRB.png": 9353,
	"./TISCO.png": 8454,
	"./TTB.png": 2434,
	"./UOB.png": 1998
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8069;